import { createFileRoute } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { SettingsPage } from "@/features/settings/section";
import { Users } from "@/features/settings/users";

export const Route = createFileRoute("/settings/users")({
  component: UsersPage,
});

/** Settings › Users: who uses the desktop app (ADR 0013). */
function UsersPage() {
  const { t } = useTranslation();
  return (
    <SettingsPage title={t("users.title")} description={t("users.body")}>
      <Users />
    </SettingsPage>
  );
}
